module.exports = __webpack_public_path__ + "img/weixin.92f579eb.svg";